export default __webpack_public_path__ + "static/media/team_background1.560c633c.jpg";